import { useCallback, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { InputWithLabel } from '@reveni-io/reveni-ui'

import { validateName } from '@/helpers'

const BankAccountUserInfo = ({ onChangeFirstName, onChangeLastName, firstName, lastName }) => {
  const { t } = useTranslation()
  const [errorFirstName, setErrorFirstName] = useState(false)
  const [errorLastName, setErrorLastName] = useState(false)

  const validateOnBlur = (setError, name) => {
    setError(!validateName(name))
  }

  const validateLastName = useCallback(() => {
    const words = lastName?.split(' ')?.filter(word => word !== '')
    if (words?.length <= 1) {
      setErrorLastName({ text: 'Recuerda introducir todos tus apellidos', error: false })
    } else if (!validateName(lastName)) {
      setErrorLastName({ text: 'Apellido no válido', error: true })
    } else {
      setErrorLastName(false)
    }
  }, [lastName])

  useEffect(() => {
    setErrorFirstName(!validateName(firstName))
    validateLastName()
  }, [firstName, validateLastName])

  return (
    <>
      <InputWithLabel
        onChange={e => onChangeFirstName(e.target.value)}
        fullWidth
        label={t('Nombre del titular (persona individual)')}
        value={firstName}
        onBlur={() => validateOnBlur(setErrorFirstName, firstName)}
        error={errorFirstName}
        helperText={errorFirstName && t('Nombre no válido')}
        name="accountHolderFirstName"
      />
      <InputWithLabel
        onChange={e => onChangeLastName(e.target.value)}
        fullWidth
        label={t('Apellidos del titular (persona individual)')}
        value={lastName}
        onBlur={() => validateLastName()}
        error={errorLastName?.error}
        helperText={errorLastName?.text && t(errorLastName?.text)}
        name="accountHolderLastName"
      />
    </>
  )
}

export default BankAccountUserInfo
